import { Planogram, PlanogramStatus, PlanogramLayout, Shelf, Product } from '../types/storeGroup';

// 模拟陈列图数据
export const mockPlanograms: Planogram[] = [
  {
    id: 'plano-001',
    planogramId: 'POG-120823-001',
    code: 'PL001',
    name: 'Benchmark Master Layout A',
    storeGroupId: 'sg-001',
    displayGroupCode: 'DG001',
    layoutName: 'Standard Layout A',
    width: 800,
    height: 600,
    shelfCount: 4,
    productCount: 12,
    importTime: '2023-08-12 09:30:00',
    importedBy: 'admin',
    fileName: 'Benchmark_Master_Layout_A.xlsx',
    status: '草稿',
    isMainVersion: true,
    layout: {
      shelves: [],
      width: 800,
      height: 600
    },
    createdAt: '2023-08-12 09:30:00',
    updatedAt: '2023-08-12 09:30:00',
    remark: '新导入的母图，待提交审核'
  },
  {
    id: 'plano-002',
    planogramId: 'POG-120823-002',
    code: 'PL002',
    name: 'Benchmark Master Layout B',
    storeGroupId: 'sg-002',
    displayGroupCode: 'DG002',
    layoutName: 'Standard Layout B',
    width: 750,
    height: 550,
    shelfCount: 3,
    productCount: 10,
    importTime: '2023-08-12 10:45:00',
    importedBy: 'admin',
    fileName: 'Benchmark_Master_Layout_B.xlsx',
    status: '待审核',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 750,
      height: 550
    },
    createdAt: '2023-08-12 10:45:00',
    updatedAt: '2023-08-12 11:00:00',
    submittedAt: '2023-08-12 11:00:00',
    remark: '已提交审核，等待审核结果'
  },
  {
    id: 'plano-003',
    planogramId: 'POG-120823-003',
    code: 'PL003',
    name: 'Flagship Store Master Layout',
    storeGroupId: 'sg-003',
    displayGroupCode: 'DG003',
    layoutName: 'Flagship Layout A',
    width: 1000,
    height: 800,
    shelfCount: 6,
    productCount: 18,
    importTime: '2023-08-12 11:20:00',
    importedBy: 'admin',
    fileName: 'Flagship_Store_Master_Layout.xlsx',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 1000,
      height: 800
    },
    createdAt: '2023-08-12 11:20:00',
    updatedAt: '2023-08-12 14:30:00',
    submittedAt: '2023-08-12 12:00:00',
    reviewedAt: '2023-08-12 14:30:00',
    reviewedBy: 'reviewer_user',
    remark: '审核通过，已生效'
  },
  {
    id: 'plano-004',
    planogramId: 'POG-130823-001',
    code: 'PL004',
    name: 'Small Store Master Layout',
    storeGroupId: 'sg-004',
    displayGroupCode: 'DG004',
    layoutName: 'Small Layout A',
    width: 500,
    height: 400,
    shelfCount: 2,
    productCount: 6,
    importTime: '2023-08-13 09:15:00',
    importedBy: 'admin',
    fileName: 'Small_Store_Master_Layout.xlsx',
    status: '草稿',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 500,
      height: 400
    },
    createdAt: '2023-08-13 09:15:00',
    updatedAt: '2023-08-13 15:45:00',
    submittedAt: '2023-08-13 10:00:00',
    reviewedAt: '2023-08-13 15:45:00',
    reviewedBy: 'reviewer_user',
    reviewNotes: '商品摆放不符合规范，需要重新调整',
    remark: '需要修改后重新提交'
  },
  {
    id: 'plano-005',
    planogramId: 'POG-130823-002',
    code: 'PL005',
    name: 'Shanghai Flagship Store Layout',
    storeGroupId: 'sg-001',
    displayGroupCode: 'DG001',
    layoutName: 'Shanghai Flagship Layout',
    width: 850,
    height: 650,
    shelfCount: 5,
    productCount: 15,
    importTime: '2023-08-13 10:30:00',
    importedBy: 'admin',
    fileName: 'Shanghai_Flagship_Store_Layout.plano',
    status: '待审核',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 850,
      height: 650
    },
    createdAt: '2023-08-13 10:30:00',
    updatedAt: '2023-08-13 10:30:00'
  },
  {
    id: 'plano-006',
    planogramId: 'POG-130823-003',
    code: 'PL006',
    name: 'Beijing Wangfujing Store Layout',
    storeGroupId: 'sg-002',
    displayGroupCode: 'DG002',
    layoutName: 'Beijing Wangfujing Layout',
    width: 800,
    height: 600,
    shelfCount: 4,
    productCount: 12,
    importTime: '2023-08-13 11:20:00',
    importedBy: 'admin',
    fileName: 'Beijing_Wangfujing_Store_Layout.plano',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 800,
      height: 600
    },
    createdAt: '2023-08-13 11:20:00',
    updatedAt: '2023-08-13 11:20:00'
  },
  {
    id: 'plano-009',
    planogramId: 'POG-130823-004',
    code: 'PL009',
    name: 'Premium Store Layout A',
    storeGroupId: 'sg-005',
    displayGroupCode: 'DG001',
    layoutName: 'Premium Layout A',
    width: 900,
    height: 700,
    shelfCount: 4,
    productCount: 14,
    importTime: '2023-08-13 11:00:00',
    importedBy: 'admin',
    fileName: 'Premium_Store_Layout_A.plano',
    status: '草稿',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 900,
      height: 700
    },
    createdAt: '2023-08-13 11:00:00',
    updatedAt: '2023-08-13 11:00:00'
  },
  // 为已通过商业和制图双重审批的store group添加更多数据
  {
    id: 'plano-011',
    planogramId: 'POG-270125-001',
    code: 'PL011',
    name: 'East China Beverages Standard Layout',
    storeGroupId: 'sg-001',
    displayGroupCode: 'DG001',
    layoutName: 'Beverages Standard Layout V2',
    width: 800,
    height: 600,
    shelfCount: 4,
    productCount: 16,
    importTime: '2025-01-27 09:00:00',
    importedBy: 'commercial_manager',
    fileName: 'East_China_Beverages_Standard_V2.xlsx',
    status: '审核完毕',
    isMainVersion: true,
    layout: {
      shelves: [],
      width: 800,
      height: 600
    },
    createdAt: '2025-01-27 09:00:00',
    updatedAt: '2025-01-27 15:30:00',
    submittedAt: '2025-01-27 10:00:00',
    reviewedAt: '2025-01-27 15:30:00',
    reviewedBy: 'planogram_director',
    remark: '已通过商业和制图双重审批，现为主版本'
  },
  {
    id: 'plano-012',
    planogramId: 'POG-270125-002',
    code: 'PL012',
    name: 'East China Beverages Promotional Layout',
    storeGroupId: 'sg-001',
    displayGroupCode: 'DG001',
    layoutName: 'Beverages Promotional Layout',
    width: 800,
    height: 600,
    shelfCount: 4,
    productCount: 18,
    importTime: '2025-01-27 10:30:00',
    importedBy: 'display_specialist',
    fileName: 'East_China_Beverages_Promotional.xlsx',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 800,
      height: 600
    },
    createdAt: '2025-01-27 10:30:00',
    updatedAt: '2025-01-27 16:45:00',
    submittedAt: '2025-01-27 11:00:00',
    reviewedAt: '2025-01-27 16:45:00',
    reviewedBy: 'planogram_manager',
    remark: '促销陈列方案，已通过审批'
  },
  {
    id: 'plano-013',
    planogramId: 'POG-270125-003',
    code: 'PL013',
    name: 'Southwest Daily Goods Optimized Layout',
    storeGroupId: 'sg-004',
    displayGroupCode: 'DG004',
    layoutName: 'Daily Goods Optimized Layout V3',
    width: 700,
    height: 500,
    shelfCount: 3,
    productCount: 12,
    importTime: '2025-01-27 11:15:00',
    importedBy: 'operations_manager',
    fileName: 'Southwest_Daily_Goods_Optimized_V3.xlsx',
    status: '审核完毕',
    isMainVersion: true,
    layout: {
      shelves: [],
      width: 700,
      height: 500
    },
    createdAt: '2025-01-27 11:15:00',
    updatedAt: '2025-01-27 17:20:00',
    submittedAt: '2025-01-27 12:00:00',
    reviewedAt: '2025-01-27 17:20:00',
    reviewedBy: 'planogram_supervisor',
    remark: '优化后的日用品陈列方案，已设为主版本'
  },
  {
    id: 'plano-014',
    planogramId: 'POG-270125-004',
    code: 'PL014',
    name: 'Southwest Daily Goods Compact Layout',
    storeGroupId: 'sg-004',
    displayGroupCode: 'DG004',
    layoutName: 'Daily Goods Compact Layout',
    width: 600,
    height: 450,
    shelfCount: 2,
    productCount: 8,
    importTime: '2025-01-27 13:45:00',
    importedBy: 'store_manager',
    fileName: 'Southwest_Daily_Goods_Compact.xlsx',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 600,
      height: 450
    },
    createdAt: '2025-01-27 13:45:00',
    updatedAt: '2025-01-27 18:10:00',
    submittedAt: '2025-01-27 14:00:00',
    reviewedAt: '2025-01-27 18:10:00',
    reviewedBy: 'planogram_specialist',
    remark: '紧凑型日用品陈列方案，适用于小型门店'
  },
  {
    id: 'plano-015',
    planogramId: 'POG-270125-005',
    code: 'PL015',
    name: 'Northwest Drinks Premium Layout',
    storeGroupId: 'sg-007',
    displayGroupCode: 'DG003',
    layoutName: 'Drinks Premium Layout V2',
    width: 850,
    height: 650,
    shelfCount: 5,
    productCount: 20,
    importTime: '2025-01-27 14:20:00',
    importedBy: 'merchandising_director',
    fileName: 'Northwest_Drinks_Premium_V2.xlsx',
    status: '审核完毕',
    isMainVersion: true,
    layout: {
      shelves: [],
      width: 850,
      height: 650
    },
    createdAt: '2025-01-27 14:20:00',
    updatedAt: '2025-01-27 19:30:00',
    submittedAt: '2025-01-27 15:00:00',
    reviewedAt: '2025-01-27 19:30:00',
    reviewedBy: 'planogram_director',
    remark: '高端饮品陈列方案，已通过双重审批并设为主版本'
  },
  {
    id: 'plano-016',
    planogramId: 'POG-270125-006',
    code: 'PL016',
    name: 'Northwest Drinks Seasonal Layout',
    storeGroupId: 'sg-007',
    displayGroupCode: 'DG003',
    layoutName: 'Drinks Seasonal Layout',
    width: 800,
    height: 600,
    shelfCount: 4,
    productCount: 16,
    importTime: '2025-01-27 15:45:00',
    importedBy: 'seasonal_planner',
    fileName: 'Northwest_Drinks_Seasonal.xlsx',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 800,
      height: 600
    },
    createdAt: '2025-01-27 15:45:00',
    updatedAt: '2025-01-27 20:15:00',
    submittedAt: '2025-01-27 16:00:00',
    reviewedAt: '2025-01-27 20:15:00',
    reviewedBy: 'planogram_manager',
    remark: '季节性饮品陈列方案，已通过审批'
  },
  {
    id: 'plano-017',
    planogramId: 'POG-270125-007',
    code: 'PL017',
    name: 'Premium Store Beverages Elite Layout',
    storeGroupId: 'sg-008',
    displayGroupCode: 'DG001',
    layoutName: 'Beverages Elite Layout V4',
    width: 1000,
    height: 800,
    shelfCount: 6,
    productCount: 24,
    importTime: '2025-01-27 16:30:00',
    importedBy: 'premium_specialist',
    fileName: 'Premium_Beverages_Elite_V4.xlsx',
    status: '审核完毕',
    isMainVersion: true,
    layout: {
      shelves: [],
      width: 1000,
      height: 800
    },
    createdAt: '2025-01-27 16:30:00',
    updatedAt: '2025-01-27 21:45:00',
    submittedAt: '2025-01-27 17:00:00',
    reviewedAt: '2025-01-27 21:45:00',
    reviewedBy: 'planogram_director',
    remark: '高端门店饮品陈列精英方案，已设为主版本'
  },
  {
    id: 'plano-018',
    planogramId: 'POG-270125-008',
    code: 'PL018',
    name: 'Premium Store Beverages Luxury Layout',
    storeGroupId: 'sg-008',
    displayGroupCode: 'DG001',
    layoutName: 'Beverages Luxury Layout',
    width: 950,
    height: 750,
    shelfCount: 5,
    productCount: 22,
    importTime: '2025-01-27 17:15:00',
    importedBy: 'luxury_coordinator',
    fileName: 'Premium_Beverages_Luxury.xlsx',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 950,
      height: 750
    },
    createdAt: '2025-01-27 17:15:00',
    updatedAt: '2025-01-27 22:30:00',
    submittedAt: '2025-01-27 18:00:00',
    reviewedAt: '2025-01-27 22:30:00',
    reviewedBy: 'planogram_supervisor',
    remark: '奢华版饮品陈列方案，专为高端客户群体设计'
  },
  {
    id: 'plano-019',
    planogramId: 'POG-270125-009',
    code: 'PL019',
    name: 'Premium Store Beverages Innovation Layout',
    storeGroupId: 'sg-008',
    displayGroupCode: 'DG001',
    layoutName: 'Beverages Innovation Layout',
    width: 900,
    height: 700,
    shelfCount: 4,
    productCount: 18,
    importTime: '2025-01-27 18:00:00',
    importedBy: 'innovation_manager',
    fileName: 'Premium_Beverages_Innovation.xlsx',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 900,
      height: 700
    },
    createdAt: '2025-01-27 18:00:00',
    updatedAt: '2025-01-27 23:15:00',
    submittedAt: '2025-01-27 18:30:00',
    reviewedAt: '2025-01-27 23:15:00',
    reviewedBy: 'planogram_expert',
    remark: '创新型饮品陈列方案，融入新技术展示理念'
  },
  {
    id: 'plano-010',
    planogramId: 'POG-130823-005',
    code: 'PL010',
    name: 'Community Store Layout A',
    storeGroupId: 'sg-006',
    displayGroupCode: 'DG002',
    layoutName: 'Community Layout A',
    width: 600,
    height: 500,
    shelfCount: 3,
    productCount: 10,
    importTime: '2023-08-13 10:20:00',
    importedBy: 'admin',
    fileName: 'Community_Store_Layout_A.plano',
    status: '审核完毕',
    isMainVersion: false,
    layout: {
      shelves: [],
      width: 600,
      height: 500
    },
    createdAt: '2023-08-13 10:20:00',
    updatedAt: '2023-08-13 10:20:00'
  }
];

// 模拟陈列图布局数据
export const mockLayouts: PlanogramLayout[] = [
  {
    width: 1000,
    height: 600,
    shelves: [
      {
        id: 'shelf-001',
        position: 1,
        height: 150,
        width: 400,
        remainingSpace: 50,
        products: []
      },
      {
        id: 'shelf-002',
        position: 2,
        height: 150,
        width: 400,
        remainingSpace: 30,
        products: []
      },
      {
        id: 'shelf-003',
        position: 3,
        height: 150,
        width: 400,
        remainingSpace: 20,
        products: []
      },
      {
        id: 'shelf-004',
        position: 4,
        height: 150,
        width: 400,
        remainingSpace: 40,
        products: []
      }
    ]
  },
  {
    width: 900,
    height: 550,
    shelves: [
      {
        id: 'shelf-005',
        position: 1,
        height: 150,
        width: 350,
        remainingSpace: 25,
        products: []
      },
      {
        id: 'shelf-006',
        position: 2,
        height: 150,
        width: 350,
        remainingSpace: 35,
        products: []
      },
      {
        id: 'shelf-007',
        position: 3,
        height: 150,
        width: 350,
        remainingSpace: 15,
        products: []
      }
    ]
  },
  {
    width: 1200,
    height: 700,
    shelves: [
      {
        id: 'shelf-008',
        position: 1,
        height: 180,
        width: 500,
        remainingSpace: 60,
        products: []
      },
      {
        id: 'shelf-009',
        position: 2,
        height: 180,
        width: 500,
        remainingSpace: 45,
        products: []
      },
      {
        id: 'shelf-010',
        position: 3,
        height: 180,
        width: 500,
        remainingSpace: 30,
        products: []
      },
      {
        id: 'shelf-011',
        position: 4,
        height: 180,
        width: 500,
        remainingSpace: 55,
        products: []
      },
      {
        id: 'shelf-012',
        position: 5,
        height: 180,
        width: 500,
        remainingSpace: 40,
        products: []
      }
    ]
  },
  {
    width: 800,
    height: 500,
    shelves: [
      {
        id: 'shelf-013',
        position: 1,
        height: 120,
        width: 300,
        remainingSpace: 20,
        products: []
      },
      {
        id: 'shelf-014',
        position: 2,
        height: 120,
        width: 300,
        remainingSpace: 25,
        products: []
      },
      {
        id: 'shelf-015',
        position: 3,
        height: 120,
        width: 300,
        remainingSpace: 15,
        products: []
      }
    ]
  },
  {
    width: 1000,
    height: 600,
    shelves: [
      {
        id: 'shelf-016',
        position: 1,
        height: 150,
        width: 400,
        remainingSpace: 50,
        products: []
      },
      {
        id: 'shelf-017',
        position: 2,
        height: 150,
        width: 400,
        remainingSpace: 30,
        products: []
      },
      {
        id: 'shelf-018',
        position: 3,
        height: 150,
        width: 400,
        remainingSpace: 20,
        products: []
      },
      {
        id: 'shelf-019',
        position: 4,
        height: 150,
        width: 400,
        remainingSpace: 40,
        products: []
      }
    ]
  },
  {
    width: 900,
    height: 550,
    shelves: [
      {
        id: 'shelf-020',
        position: 1,
        height: 150,
        width: 350,
        remainingSpace: 25,
        products: []
      },
      {
        id: 'shelf-021',
        position: 2,
        height: 150,
        width: 350,
        remainingSpace: 35,
        products: []
      },
      {
        id: 'shelf-022',
        position: 3,
        height: 150,
        width: 350,
        remainingSpace: 15,
        products: []
      }
    ]
  },
  {
    width: 1200,
    height: 700,
    shelves: [
      {
        id: 'shelf-023',
        position: 1,
        height: 180,
        width: 500,
        remainingSpace: 60,
        products: []
      },
      {
        id: 'shelf-024',
        position: 2,
        height: 180,
        width: 500,
        remainingSpace: 45,
        products: []
      },
      {
        id: 'shelf-025',
        position: 3,
        height: 180,
        width: 500,
        remainingSpace: 30,
        products: []
      },
      {
        id: 'shelf-026',
        position: 4,
        height: 180,
        width: 500,
        remainingSpace: 55,
        products: []
      },
      {
        id: 'shelf-027',
        position: 5,
        height: 180,
        width: 500,
        remainingSpace: 40,
        products: []
      }
    ]
  }
];

// 模拟货架数据
export const mockShelves: Shelf[] = [
  {
    id: 'shelf-001',
    position: 1,
    height: 150,
    width: 400,
    remainingSpace: 50,
    products: [
      {
        id: 'product-001',
        code: 'PROD001',
        name: 'Coca-Cola 330ml',
        width: 8,
        position: 1,
        facings: 4,
        inventory: 120,
        dailySales: 15,
        suggestedFacings: 5,
        affectedStores: 25
      },
      {
        id: 'product-002',
        code: 'PROD002',
        name: 'Pepsi 330ml',
        width: 8,
        position: 2,
        facings: 4,
        inventory: 100,
        dailySales: 12,
        suggestedFacings: 4,
        affectedStores: 22
      },
      {
        id: 'product-003',
        code: 'PROD003',
        name: 'Sprite 330ml',
        width: 8,
        position: 3,
        facings: 3,
        inventory: 80,
        dailySales: 10,
        suggestedFacings: 3,
        affectedStores: 18
      },
      {
        id: 'product-004',
        code: 'PROD004',
        name: 'Fanta 330ml',
        width: 8,
        position: 4,
        facings: 3,
        inventory: 75,
        dailySales: 8,
        suggestedFacings: 3,
        affectedStores: 15
      },
      {
        id: 'product-005',
        code: 'PROD005',
        name: 'Fresh Orange Juice 550ml',
        width: 10,
        position: 5,
        facings: 2,
        inventory: 60,
        dailySales: 6,
        suggestedFacings: 2,
        affectedStores: 12
      },
      {
        id: 'product-006',
        code: 'PROD006',
        name: 'Potato Chips 104g',
        width: 12,
        position: 6,
        facings: 2,
        inventory: 45,
        dailySales: 5,
        suggestedFacings: 2,
        affectedStores: 10
      }
    ]
  },
  {
    id: 'shelf-002',
    position: 2,
    height: 150,
    width: 400,
    remainingSpace: 30,
    products: [
      {
        id: 'product-007',
        code: 'PROD007',
        name: 'Corn Chips 104g',
        width: 12,
        position: 1,
        facings: 2,
        inventory: 40,
        dailySales: 4,
        suggestedFacings: 2,
        affectedStores: 8
      },
      {
        id: 'product-008',
        code: 'PROD008',
        name: 'Milk Chocolate 40g',
        width: 6,
        position: 2,
        facings: 4,
        inventory: 90,
        dailySales: 9,
        suggestedFacings: 4,
        affectedStores: 20
      },
      {
        id: 'product-009',
        code: 'PROD009',
        name: 'Head & Shoulders Shampoo 750ml',
        width: 15,
        position: 3,
        facings: 2,
        inventory: 35,
        dailySales: 3,
        suggestedFacings: 2,
        affectedStores: 7
      },
      {
        id: 'product-010',
        code: 'PROD010',
        name: 'Dove Body Wash 720ml',
        width: 15,
        position: 4,
        facings: 2,
        inventory: 30,
        dailySales: 2,
        suggestedFacings: 2,
        affectedStores: 6
      }
    ]
  }
];

// 模拟商品数据
export const mockProducts: Product[] = [
  {
    id: 'product-001',
    code: 'P001',
    name: 'Coca-Cola 330ml',
    width: 8,
    position: 1,
    facings: 4,
    inventory: 120,
    dailySales: 15,
    suggestedFacings: 5,
    affectedStores: 25
  },
  {
    id: 'product-002',
    code: 'P002',
    name: 'Pepsi 330ml',
    width: 8,
    position: 2,
    facings: 4,
    inventory: 100,
    dailySales: 12,
    suggestedFacings: 4,
    affectedStores: 22
  },
  {
    id: 'product-003',
    code: 'P003',
    name: 'Sprite 330ml',
    width: 8,
    position: 3,
    facings: 3,
    inventory: 80,
    dailySales: 10,
    suggestedFacings: 3,
    affectedStores: 18
  },
  {
    id: 'product-004',
    code: 'P004',
    name: 'Fanta 330ml',
    width: 8,
    position: 4,
    facings: 3,
    inventory: 75,
    dailySales: 8,
    suggestedFacings: 3,
    affectedStores: 15
  },
  {
    id: 'product-005',
    code: 'P005',
    name: 'Fresh Orange Juice 550ml',
    width: 10,
    position: 5,
    facings: 2,
    inventory: 60,
    dailySales: 6,
    suggestedFacings: 2,
    affectedStores: 12
  },
  {
    id: 'product-006',
    code: 'P006',
    name: 'Potato Chips 104g',
    width: 12,
    position: 6,
    facings: 2,
    inventory: 45,
    dailySales: 5,
    suggestedFacings: 2,
    affectedStores: 10
  },
  {
    id: 'product-007',
    code: 'P007',
    name: 'Corn Chips 104g',
    width: 12,
    position: 1,
    facings: 2,
    inventory: 40,
    dailySales: 4,
    suggestedFacings: 2,
    affectedStores: 8
  },
  {
    id: 'product-008',
    code: 'P008',
    name: 'Milk Chocolate 40g',
    width: 6,
    position: 2,
    facings: 4,
    inventory: 90,
    dailySales: 9,
    suggestedFacings: 4,
    affectedStores: 20
  },
  {
    id: 'product-009',
    code: 'P009',
    name: 'Head & Shoulders Shampoo 750ml',
    width: 15,
    position: 3,
    facings: 2,
    inventory: 35,
    dailySales: 3,
    suggestedFacings: 2,
    affectedStores: 7
  },
  {
    id: 'product-010',
    code: 'P010',
    name: 'Dove Body Wash 720ml',
    width: 15,
    position: 4,
    facings: 2,
    inventory: 30,
    dailySales: 2,
    suggestedFacings: 2,
    affectedStores: 6
  }
];

// 模拟陈列图状态选项
export const PLANOGRAM_STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'Active', label: 'Active' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Archived', label: 'Archived' },
];

// 状态颜色
export const PLANOGRAM_STATUS_COLORS = {
  Active: '#52c41a',
  Draft: '#faad14',
  Archived: '#ff4d4f',
};

// 状态标签
export const PLANOGRAM_STATUS_LABELS = {
  Active: '激活',
  Inactive: '停用',
};